import CIMSFormItem from 'components/CIMSFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { HelpMessage } from 'utils/constants'
import { useIssueTypesContext } from '../../IssueTypesContext'

const CreateEditFormItems: React.VFC = () => {
  const { dispositionTypes, loading } = useIssueTypesContext()
  return (
    <>
      <NameFormItem help={HelpMessage.Name} />
      <DescriptionFormItem entityName="Type" />
      <CIMSFormItem
        name="nonApplicableDispositionTypes"
        label="Non-Applicable Disposition Types"
        help={HelpMessage.Issues.IssueTypes.NonApplicableDispositionTypes}
      >
        <CIMSSelect multiple options={dispositionTypes} loading={loading} />
      </CIMSFormItem>
    </>
  )
}

export default CreateEditFormItems
